import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      alignItems: 'center',
      backgroundColor: COLORS.neutral.white,
    },
    layout: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      flex: '1 1!important',
    },
    wrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    logo: {
      position: 'absolute',
      left: theme.spacing(3),
      top: theme.spacing(3),

      '& svg': {
        fontSize: theme.typography.pxToRem(27),
      },
    },
    form: {
      alignSelf: 'stretch',
    },
    linkSwitchState: {
      ...theme.typography.regular16,
      marginTop: theme.spacing(2),

      '&:hover:enabled': {
        color: COLORS.primary.default,
        textDecoration: 'underline',
      },
    },
    contactUsLink: {
      position: 'absolute',
      bottom: 0,
      marginBottom: theme.spacing(2),
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray30,
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    rightPanel: {
      flexShrink: 0,
    },
  }),
  { name: 'SignInPage' }
);
